module.exports = __webpack_public_path__ + "static/OE9103020-719dd019327d07a631daa6dddc862abe.jpg";